module.exports = __webpack_public_path__ + "92a83a78d6bd8974e187ae41b4c9fc2c.pdf";